/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tag/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Match from './Match/index'
import No from './No/index'
import NoMatch from './NoMatch/index'
import Partial from './Partial/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Tag({
  children,
  viewPath = "/DesignSystem/SyncPatientMatchingCard/Tag"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let cardTypeValueData = fromData.useDataValue({ viewPath,
context: 'card',
path: 'type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: cardTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'NoMatch'}>
<NoMatch
  viewPath={`${viewPath}/NoMatch`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Partial'}>
<Partial
  viewPath={`${viewPath}/Partial`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Match'}>
<Match
  viewPath={`${viewPath}/Match`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}